import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { NewProblemForm } from '@/features/AdminProblems/NewProblemForm';

export const Route = createFileRoute('/admin/problems/new')({
  component: NewProblemPage,
});

function NewProblemPage() {
  const navigate = useNavigate();
  return (
    <NewProblemForm
      onBack={() => navigate({ to: '/admin/problems' })}
      onCreated={id => navigate({ to: '/admin/problems/$problemId', params: { problemId: id } })}
    />
  );
}
